import styled, { keyframes } from "styled-components";
import { NavLink } from "react-router-dom";
import { HiOutlineDotsCircleHorizontal } from 'react-icons/hi'
import CalendarTodayRoundedIcon from '@material-ui/icons/CalendarTodayRounded';
import PersonIcon from '@material-ui/icons/Person';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';

const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: translateX(-200px);;
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
`;

export const Cointainer = styled.div`
  width: 95px;
  background-color: #2196f3;
  margin-top: 191px;
  height: 100vh;
  border-radius: 0px 40px 0px 0px;
  position: fixed;
  z-index:999;
  animation: ${fadeIn} 0.5s ease 0s;
  @media(max-width:990px){
    margin-top: 63px;
    left:0;
    }
`;

export const CustomNavLink = styled(NavLink)`
  margin-left: 10px;
  padding: 15px;
  display: block;
  color: white;

  .active {
    
    background-color: white;
  }
`;

export const CustomNavLink1 = styled.div`
  margin-left: 10px;
  padding: 15px;
  display: block;
  .active {
    border-radius: 50px 0px 0px 50px;
    background-color: white;
  }
`;

export const CPersonIcon = styled(PersonIcon)`
  color:white;
  &:hover{
    color:grey;
  }
`
export const CPersonOutlineIcon = styled(PersonOutlineIcon)`
  color:white;

  }
`
export const CHiOutlineDotsCircleHorizontal = styled(HiOutlineDotsCircleHorizontal)`
  color:white;

  }
`
export const CBiCalendar = styled(CalendarTodayRoundedIcon)`
  color:white;
  &:hover{
    color:grey;
  }
`